import React, { useEffect } from "react";
import { useState } from "react";
import { Box, File, FileText, List, Paperclip, Pocket, Settings, User, Users } from "react-feather";
import TopBar from "../../components/menu/TopBar";
import Menu from "./detailsSideMenu.jsx/Menu";
import AppTabs from "./tabsForClaimDetails/AppTabs";
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from "react-redux";
import { appViewDetails, resetAppViewDetails, resetDataFetched, resetInitialTab } from "../../stores/slices/appViewDetailsSlice";
import { fetchDocList } from "../../utilities/API/document/documentAPI";
import { fetchAppDocList } from "../../stores/slices/document/documentListSlice";
import Loader from "../../components/menu/Loader";
import PayableTo from "./tabsForClaimDetails/PayableTo";
import Attachments from "./tabsForClaimDetails/Attachments";
import ClaimsInfo from "./tabsForClaimDetails/ClaimsInfo";
import DenialReason from "./tabsForClaimDetails/DenialReason";
import { fetchClaimDetailsDoc, resetClaimDataFetched, resetClaimDetails } from "../../stores/slices/claimDetailSlice";

function ClaimDetails() {
  const dispatch = useDispatch();
  const loginData = useSelector((state) => state.loginSlice);
  const ClaimData = useSelector((state) => state.claimDetailSlice);
  const [appDetails, setAppDetails] = useState([]);
  const [selectedTab, setSelectedTab] = useState(1);
  const [loader, setLoader] = useState(true)

  const docList = () => {
    let data = {
      portalUserID: loginData.value.PortalUserID,
      ClaimID: ClaimData.claimId
    }
    dispatch(fetchClaimDetailsDoc({ PCaseID: data, prgData: ClaimData.program }))
    setAppDetails([

      {
        id: 1,
        icon: <User />,
        menuLabel: 'Claim Info',
        component: <ClaimsInfo />
      },
      {
        id: 2,
        icon: <Pocket />,
        menuLabel: 'Denial Reasons',
        component: <DenialReason />
      },
      {
        id: 3,
        icon: <Users />,
        menuLabel: 'Payable To',
        component: <PayableTo />
      },
      {
        id: 4,
        icon: <Paperclip />,
        menuLabel: 'Attachments',
        component: <Attachments />
      },
    ])

    setLoader(false);
    dispatch(resetClaimDataFetched())
  }

  ClaimData.isDataFetched && docList()

  useEffect(() => {
    setAppDetails([

      {
        id: 1,
        icon: <User />,
        menuLabel: 'Claim Info',
        component: <ClaimsInfo />
      },
      {
        id: 2,
        icon: <Pocket />,
        menuLabel: 'Denial Reasons',
        component: <DenialReason />
      },
      {
        id: 3,
        icon: <Users />,
        menuLabel: 'Payable To',
        component: <PayableTo />
      },
      {
        id: 4,
        icon: <Paperclip />,
        menuLabel: 'Attachments',
        component: <Attachments />
      },

    ])
    return () => {
      dispatch(resetClaimDetails());
      dispatch(resetInitialTab(1))
    };

  }, [])

  const onClickSlectedtab = (id) => {
    setSelectedTab(id);
  }

  return (
    <div className="content">
      <TopBar />
      <div class="intro-y box px-5 pt-5 mt-5">
        {loader && <Loader />}

        <div className="d-flex flex-column flex-lg-row ">
          <div className="d-flex flex-1 py-4">
            <div className="ms-1">
              <div className="fw-medium">Claim ID</div>
              <div className="text-gray-600">{ClaimData.claimId}</div>
            </div>
          </div>
          <div className="d-flex flex-1 py-4">
            <div className="ms-1">
              <div className="fw-medium">Program</div>
              <div className="text-gray-600">{ClaimData.program == "CPR" ? "TotalAssist" : ClaimData.program }</div>
            </div>
          </div>
          <div className="d-flex flex-1  py-4">
            <div className="ms-1">
              <div className="fw-medium">Reference ID</div>
              <div className="text-gray-600">{ClaimData.applicationId}</div>
            </div>
          </div>
          <div className="d-flex flex-1 py-4">
            <div className="ms-1">
              <div className="fw-medium">Patient Name</div>
              <div className="text-gray-600">{ClaimData.patientname}</div>
            </div>
          </div>
          <div className="d-flex flex-1 py-4">
            <div className="ms-1">
              <div className="fw-medium">Status</div>
              <div className="text-gray-600">{ClaimData.status}</div>
            </div>
          </div>
        </div>

        <div class="grid columns-12 gap-6 pb-6">
          <div class="g-col-12 g-col-lg-4 g-col-xxl-3 d-flex d-lg-block flex-column-reverse">
            <div class="intro-y box mt-5">
              <Menu data={appDetails} selected={selectedTab} onClickSelect={onClickSlectedtab} />
            </div>
          </div>
          <AppTabs data={appDetails} selected={selectedTab} />
        </div>
      </div>
    </div>
  );
}

export default ClaimDetails;
